import React from 'react';
import { useFetch, useApiClient } from '@marageti/z4-lib';
import { TripMatch, TripMatchStatus } from '@marageti/z4-sdk/lib/travel';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import TripRequestTripMatchesView from './trip-request-trip-matches-view';

type TripRequestTripMatchesContainerProps = {
  tripRequestId: string | undefined;
  onTripRequestChange?: () => void;
};

const TripRequestTripMatchesContainer = ({
  tripRequestId,
  onTripRequestChange,
}: TripRequestTripMatchesContainerProps) => {
  const apiClient = useApiClient();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const tripMatches = useFetch<TripMatch[]>(
    apiClient.tripRequestsClient.getTripRequestTripMatches,
    [tripRequestId],
    !!tripRequestId,
  );

  const onClickCancel = (id: string) => {
    navigate(`matches/${id}`);
  };

  const onSoldCanceled = () => {
    tripMatches.mutate();
    onTripRequestChange?.();
  };

  const onClickReactivate = (id: string) => {
    apiClient.tripMatchesClient
      .putTripMatchStatus(id, {
        id,
        status: TripMatchStatus.MatchPending,
        statusInfo: {
          reason: 'Reactivated Partner Declined Match',
        },
      })
      .then(() => {
        tripMatches.mutate();
        enqueueSnackbar('Match reactivated', { variant: 'success' });
      })
      .catch((e: ApiError) => {
        if (e?.code === 401) navigate('/logout');
        enqueueSnackbar('Match status was not changed', { variant: 'default' });
      });
  };

  return (
    <TripRequestTripMatchesView
      tripRequestId={tripRequestId}
      tripMatches={tripMatches}
      onCancelClick={onClickCancel}
      onClickReactivate={onClickReactivate}
      onSoldCanceled={onSoldCanceled}
    />
  );
};

export default TripRequestTripMatchesContainer;
